import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {useHistory} from 'react-router-dom'
import {ReactComponent as NewSvg} from '../../../assets/icons/new.svg';

import {getNotificationType, notificationsTypesInfo} from '../../../helpers/notifications'
import Colors from '../../../themes/Colors'
import dayjs from 'dayjs'
import {dateFormatWithTime} from '../../../helpers/constants'
import {ButtonMUI} from '../../../shared'
import "./style.scss"
import {useDispatch} from "react-redux";
import {readNotificationById, updateNotificationCount} from "../../../redux/actions/profile/profileActions";

const initialProps = {
    notification: null,
    onRemove: () => {
    },
    onClose: () => {
    },
    push: false,
    onRead: () => {
    },
}

const Notification = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const {t} = useTranslation()
    const {notification, onRead, onClose} = {...initialProps, ...props}

    const {messageBody} = notification

    const notificationType = useMemo(
        () => getNotificationType(notification),
        [notification]
    )

    const notificationsType = useMemo(() => notificationsTypesInfo(t), [t])

    const iconColor = !notification.isRead ? Colors.white : Colors.white

    return (
        <div
            className={classNames(
                'notification-wrapper',
                {'notification-wrapper--disabled': notification.isRead}
            )}
            onClick={() => {
                if (props.push) {
                    dispatch(readNotificationById(notification.id)).then((res) => {
                        if (res.payload) {
                            notificationsType[notificationType].action({
                                history,
                                params: messageBody
                            })
                            dispatch(updateNotificationCount('minus'))
                            onClose();
                        }
                    })
                }
            }}
        >
            <div className="notification-icon-container">
                <div
                    className={classNames(
                        'notification-icon-wrapper',
                        {'notification-icon-wrapper--disabled': notification.isRead}
                    )}
                    style={!notification.isRead ? {backgroundColor: notificationsType[notificationType].color} : {backgroundColor: Colors.grey}}
                >
                    {notificationsType[notificationType].icon({
                        size: 18,
                        color: iconColor,
                    })}
                </div>
            </div>

            <div className="notification-content">
                <div className="notification-head">
                    <div className="notification-title-wrapper">
                        {notificationsType[notificationType].title}
                    </div>
                    {!props.push && <div className="notification-date-wrapper">
                        {dayjs(notification.createdAt).format(dateFormatWithTime)}
                    </div>}

                </div>

                <div className="notification-message">
                    {messageBody?.message}
                </div>

                {!!notificationsType[notificationType]?.action && !props.push && (
                    <div className="notification-button-wrapper">
                        <ButtonMUI
                            size="small"
                            color={'default'}
                            onClick={() => {
                                onRead(notification.id, notification.isRead)
                                notificationsType[notificationType].action({
                                    history,
                                    params: messageBody
                                })
                            }}
                            // disabled={notification.isRead}
                        >
                            {notificationsType[notificationType].actionLabel}
                        </ButtonMUI>

                        <ButtonMUI
                            onClick={() => {
                                props.onRemove(notification.id)
                            }}
                            size="small"
                            color={'secondary'}
                        >
                            Видалити
                        </ButtonMUI>
                    </div>
                )}
            </div>
            {!notification.isRead && !props.push && <NewSvg className={'notification-new'}/>}
        </div>
    )
}

export default Notification
